import { useTranslation } from 'react-i18next';
import {FunctionComponent} from 'react';
import {Button, Col, DatePicker, Form, Row, Typography} from "antd";
import {DeleteOutlined, FilterOutlined} from "@ant-design/icons";
import "./filter-group.scss"
import {useForm} from "antd/es/form/Form";
import {FormInstance} from "antd/lib";
import FormItemDropdown from '../../../../../components/form-dropdown/FormItemDropdown';
import { dataStatus } from '../../constants/data';

type FormFilterProps = {
  showFilter?: boolean
  clearFilter: (form: FormInstance) => void,
  onFinish?: any,
  dataOptions?: any
}

const FormFilter: FunctionComponent<FormFilterProps> = ({ onFinish, showFilter, clearFilter, dataOptions, }) => {
  const { t } = useTranslation();
  const [form] = useForm();
  const { RangePicker } = DatePicker;
  return (
    <>
      <div className={`wrapper-filter ${showFilter ? "open" : ""}`}>
        <Form name="filterForm" onFinish={onFinish} form={form}>
          <Row gutter={[{xs: 8, xl: 24, md: 16}, 12]}>
            <Col xl={{span: 6}} md={{span: 5}} sm={{span: 5}} xs={{span: 24}}>
              <Typography.Title level={5}>{t('Thời gian', 'Thời gian')}</Typography.Title>
              <Form.Item name="time">
                <DatePicker.RangePicker allowEmpty={[true, true]} placeholder={[t("Bắt đầu", "Bắt đầu"), t("Kết thúc", "Kết thúc")]} format='DD/MM/YYYY' />
              </Form.Item>
            </Col>
            <Col xl={{span: 6}} md={{span: 5}} sm={{span: 5}} xs={{span: 24}}>
              <Typography.Title level={5}>{t("Trạng thái", "Trạng thái")}</Typography.Title>
              <Form.Item name="status">
                <FormItemDropdown placeholder={t("Chọn trạng thái", "Chọn trạng thái")} options={dataStatus}/>
              </Form.Item>
            </Col>
            <Col xl={{span: 3}} md={{span: 9}} sm={{span: 9}} xs={{span: 24}} className="flex align-end">
              <div className="group-btn--filter">
                <Button className="btn btn-primary filter-btn" htmlType="submit">
                  <FilterOutlined/>
                  <Typography.Text> {t('Lọc', 'Lọc')} </Typography.Text>
                </Button>
                <Button className="btn btn-outlined clear-filter-btn" onClick={() => clearFilter(form)}>
                  <DeleteOutlined/>
                  <Typography.Text> {t('Xóa bộ lọc', 'Xóa bộ lọc')} </Typography.Text>
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default FormFilter;
